export const printIPTicket = async (
  order,
  total,
  appliedPayments,
  property,
  deviceConfig,
  selectedRevenue,
  selectedSpace,
  chequeSeleccionado,
  currentUser,
  printerConfig
) => {
  try {
    // Validar configuración
    if (!printerConfig.IP || !printerConfig.Port) {
      throw new Error("Configuración de impresora IP incompleta");
    }

    // Construir el contenido del ticket (misma plantilla que antes)
    const ticketContent = `
      Propiedad: ${property}
      Dispositivo: ${deviceConfig.name}
      Revenue: ${selectedRevenue?.name || "N/A"}
      Mesa: ${selectedSpace?.name || "N/A"}
      Cheque: ${chequeSeleccionado || "N/A"}
      Usuario: ${currentUser?.nombre || "N/A"}
      -----------------------
      Productos:
      ${order
        .map(
          (item) =>
            `${item.name} x${item.quantity} - $${(item.price * item.quantity).toFixed(2)}`
        )
        .join("\n")}
      -----------------------
      Total: $${total.toFixed(2)}
      Pagos:
      ${appliedPayments
        .map((p) => `${p.method.name}: $${p.amount.toFixed(2)}`)
        .join("\n")}
      -----------------------
      Fecha: ${new Date().toLocaleString()}
    `;

    // Simulación de envío a la impresora IP (reemplazar con tu implementación real)
    console.log(`Enviando a impresora IP ${printerConfig.IP}:${printerConfig.Port}`);
    console.log("Contenido del ticket:", ticketContent);

    // Aquí iría la lógica real para conectar con la impresora IP, por ejemplo, usando una librería como `escpos` o una API de red
    // Ejemplo: await sendToIPPrinter(printerConfig.IP, printerConfig.Port, ticketContent);

    return { success: true, message: "Ticket enviado a la impresora IP" };
  } catch (error) {
    console.error("Error al imprimir en impresora IP:", error);
    return { success: false, message: `Error al imprimir: ${error.message}` };
  }
};